import React from 'react';
import { 
  ArrowRight,
  Sparkles 
} from 'lucide-react';
import { Link } from 'react-router-dom';

const Services = () => {
  const services = [
    {
      image: '/images/finance-8836902_1280.jpg',
      title: 'Investment Management',
      description: 'Comprehensive investment management services designed to help you achieve your financial goals. Our expert team provides tailored strategies and portfolio management to maximize returns.',
      route: '/services/investment-management'
    },
    {
      image: '/images/analysis-1841158_1280.jpg',
      title: 'Financial Planning',
      description: 'Create a comprehensive financial roadmap with our personalized planning services. Our experts help you develop strategies for wealth building and management.',
      route: '/services/financial-planning'
    },
    {
      image: '/images/senior-4723737_640.jpg',
      title: 'Retirement Planning',
      description: 'Secure your future with our retirement planning solutions. We help you build a nest egg that ensures financial independence and peace of mind during your golden years.',
      route: '/services/retirement-planning'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-20" data-aos="fade-up">
          <div className="inline-flex items-center px-4 py-2 bg-gold-100 rounded-full mb-6">
            <Sparkles className="h-4 w-4 text-gold-600 mr-2" />
            <span className="text-gold-700 text-sm font-semibold">Our Services</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold font-serif text-navy-900 mb-6">
            Our Services
          </h2>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Comprehensive financial solutions for individuals and businesses - from investments to loans and retirement planning.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            return (
              <div
                key={service.title}
                className="service-card group cursor-pointer overflow-hidden"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                {/* Image */}
                <div className="relative h-48 mb-6 rounded-xl overflow-hidden group-hover:scale-105 transition-transform duration-300">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy-900/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>

                {/* Content */}
                <h3 className="text-2xl font-bold text-navy-900 mb-4 group-hover:text-gold-600 transition-colors">
                  {service.title}
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>

                {/* CTA */}
                <Link 
                  to={service.route}
                  className="group/btn flex items-center text-gold-600 font-semibold hover:text-gold-700 transition-colors"
                >
                  Learn More
                  <ArrowRight className="ml-2 h-4 w-4 group-hover/btn:translate-x-1 transition-transform" />
                </Link>
              </div>
            );
          })}
        </div>


      </div>
    </section>
  );
};

export default Services; 